import { useFormContext } from 'react-hook-form';
import { SignInputPhone } from '@/module/auth/sign-up';
import { useCountryCode } from '@/shared/hooks';
import { type UserType } from '@/types';
import { PhoneVerificationBanner } from '../PhoneVerificationBanner';
import { type ProfileEditFormData } from '../schema';
import { PhoneVerificationForm } from './PhoneVerificationForm';
export const PhoneSectionInForm = ({
  type
}: {
  type: Exclude<UserType, 'student' | 'unknown'>;
}) => {
  const {
    isKR
  } = useCountryCode();
  const {
    watch
  } = useFormContext<ProfileEditFormData>();
  const verifiedPhoneNumber = watch('verifiedPhoneNumber');
  if (!isKR) {
    return <SignInputPhone type={type} />;
  }
  return verifiedPhoneNumber ? <PhoneVerificationForm data-sentry-element="PhoneVerificationForm" data-sentry-component="PhoneSectionInForm" data-sentry-source-file="PhoneSectionInForm.tsx" /> : <PhoneVerificationBanner data-sentry-element="PhoneVerificationBanner" data-sentry-component="PhoneSectionInForm" data-sentry-source-file="PhoneSectionInForm.tsx" />;
};